{
  "massPerCubicMetre": 0.2,
  "fractureMassT": 400,
  "fractureValue": 25000,
  "archetypeOres": {
    "A": { "ferrite": 0.2, "silicates": 0.45, "ice": 0.3, "titanium": 0.05 },
    "B": { "ferrite": 0.35, "silicates": 0.5, "titanium": 0.12, "platinum": 0.03 },
    "C": { "ferrite": 0.2, "silicates": 0.4, "ice": 0.3, "titanium": 0.08, "platinum": 0.02 },
    "D": { "ferrite": 0.3, "silicates": 0.3, "ice": 0.2, "titanium": 0.15, "platinum": 0.05 },
    "E": { "ferrite": 0.55, "silicates": 0.03, "titanium": 0.3, "platinum": 0.12 },
    "F": { "ferrite": 0.05, "silicates": 0.2, "ice": 0.75 }
  },
  "mix": { "jitter": 0.5, "maxOres": 4, "fieldBlend": 0.5, "gradeMassMult": true },
  "tetherstone": { "chance": 0.05, "share": [0.02, 0.05] },
  "beam": { "range": 300, "socket": "HP_LASER_C" },
  "booms": { "rangeM": 600, "arcDeg": 70, "heatShare": 1 },
  "scan": { "holdSeconds": 1, "valueSpreadMk1": 0.3, "valueSpreadMk2": 0.1 },
  "chip": {
    "intervalSeconds": 1.5,
    "chunkMassT": [0.2, 1.0],
    "ejectSpeed": [2, 6],
    "fragmentYieldMult": 1.5,
    "chunkLifeSeconds": 60,
    "poolCapacity": 256,
    "chipPower": 0.5
  },
  "collector": { "range": 60, "halfAngleDeg": 30, "pullAccel": 12, "maxPullSpeed": 25, "captureDistance": 4 },
  "fracture": {
    "tiers": 3,
    "windowWidth": [0.3, 0.12],
    "windowSpeed": [0.03, 0.12],
    "fractureSeconds": 15,
    "belowDecay": 0.2,
    "instabilityPerOvershoot": 4.0,
    "instabilityDecay": 0.15,
    "powerStep": 0.05,
    "powerSmoothing": 6,
    "disengageSeconds": 2,
    "fragments": [4, 8],
    "fragmentSpread": 0.6,
    "fragmentPoolCapacity": 96,
    "burst": { "damage": [40, 120], "radius": 150, "oreLoss": 0.7, "chunks": [6, 12], "maxChunkTonnes": 12 }
  },
  "heat": { "ratePerPower": 0.12, "coolRate": 0.2, "overheatCooldownSeconds": 4 }
}
